/* jshint esversion: 6 */
/* jshint esversion: 8 */
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAPFLgnKnd-s9cBJieyBr-8wdgsDKRNn5w",
  authDomain: "delivery-king-c74cb.firebaseapp.com",
  projectId: "delivery-king-c74cb",
  storageBucket: "delivery-king-c74cb.firebasestorage.app",
  messagingSenderId: "634529334132",
  appId: "1:634529334132:web:98e9e8f0b87d0b07022221",
  measurementId: "G-MNXCB7BF15"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const database = getDatabase(app);

const vapidKey = "BEHhwLvhkw7urKd-6gYvjwMpRnScl_nArs2uCUQO5f5cd6q4KGpWQsT9X2f2OZgSpRXHFwxsk9z1LNQn5ADAtoM";
const messaging = getMessaging(app);

export const RecvestToken = async () => {
  return Notification.requestPermission()
    .then((permission) => {
      if (permission === "granted") {
        const Token = getToken(messaging, { vapidKey });
        return Token;
      }
    });
};

export { db, auth, database, messaging };